<template>
    <v-container app>
        <v-dialog v-model="dialog" persistent max-width="1200px">
            <template v-slot:activator="{ on, attrs }">
                <v-btn color="#395384" class="white--text" dark v-bind="attrs" v-on="on" @click="addEmployee()">
                    Añadir Empleado
                </v-btn>
                <br />
            </template>
            <v-card>
                <v-card-title>
                    <span class="text-h5">User Profile</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-form ref="form" v-model="valid">
                                <P>Datos de contacto</P>
                                <v-divider></v-divider>
                                <br />
                                <v-row>
                                    <v-col cols="12" sm="4" md="4">
                                        <v-text-field v-model="datosempleados.nombres" label="Nombres*" required clearable
                                            variant="solo-filled" :rules="nameRules"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="4" md="4">
                                        <v-text-field v-model="datosempleados.apellidoPaterno" label="Apellido Paterno*"
                                            required clearable variant="solo-filled" :rules="nameRules"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="4" md="4">
                                        <v-text-field v-model="datosempleados.apellidoMaterno" label="Apellido Materno*"
                                            required clearable variant="solo-filled" :rules="nameRules"></v-text-field>
                                    </v-col>

                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field v-model="datosempleados.telefono" label="Teléfono*" required clearable
                                            variant="solo-filled" :rules="phoneRules" maxlength="10"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field v-model="datosempleados.email" label="Email" required clearable
                                            variant="solo-filled" :rules="emailRules"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field v-model="datosempleados.curp" label="CURP" required clearable
                                            variant="solo-filled" :rules="curpRules" maxlength="18"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field v-model="datosempleados.rfc" label="RFC" required clearable
                                            variant="solo-filled" :rules="rfcRules" maxlength="13"></v-text-field>
                                    </v-col>
                                </v-row>
                                <br />
                                <P>Direccion</P>
                                <v-divider></v-divider>
                                <br />
                                <v-row>
                                    <v-col cols="12" sm="3" md="3">
                                        <v-text-field v-model="datosempleados.cruzamiento1" label="Cruzamiento 1*" required
                                            clearable variant="solo-filled" :rules="countriRules"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="3" md="3">
                                        <v-text-field v-model="datosempleados.cruzamiento2" label="Cruzamiento 2" required
                                            clearable variant="solo-filled"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="3" md="3"><v-text-field v-model="datosempleados.numeroInterior"
                                            label="Número Interior*" required clearable variant="solo-filled"
                                            :rules="countriRules"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="3" md="3">
                                        <v-text-field v-model="datosempleados.numeroExterior"
                                            label="Número Exterior"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="4">
                                        <v-text-field v-model="datosempleados.codigoPostal" label="Código Postal*" required
                                            clearable variant="solo-filled" :rules="postalCodeRules"
                                            maxlength="5"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="4">
                                        <v-text-field v-model="datosempleados.pais" label="País" required clearable
                                            variant="solo-filled" :rules="countriRules"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="4"><v-text-field v-model="datosempleados.entidad"
                                            label="Entidad*" required clearable variant="solo-filled"
                                            :rules="countriRules"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="4"><v-text-field v-model="datosempleados.municipio"
                                            label="Municipio*" required clearable variant="solo-filled"
                                            :rules="countriRules"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="4">
                                        <v-text-field v-model="datosempleados.localidad" label="Localidad" required
                                            clearable variant="solo-filled" :rules="countriRules"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="4"><v-text-field v-model="datosempleados.colonia"
                                            label="Colonia" required clearable variant="solo-filled"
                                            :rules="countriRules"></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-form>
                        </v-row>
                    </v-container>
                    <P>*indicates required field</P>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="ma-2 white--text" color="red accent-4" elevation="4" @click="dialog = false">
                        Close
                    </v-btn>
                    <v-btn class="ma-2 white--text" color="indigo darken-4" variant="flat" elevation="4"
                        @click="(dialog = false), submitForm()" type="submit" :disabled="!valid">
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <br />
        <v-divider></v-divider>
        <br />
        <div class="tableCostumers">
            <v-card color="#395384" class="white--text">
                <v-card-title>
                    Empleados
                    <v-spacer></v-spacer>
                    <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details
                        solo></v-text-field>
                </v-card-title>
                <v-data-table :headers="headers" :items="Employees" :search="search">
                    <template v-slot:item="props">
                        <tr>
                            <td>{{ props.item.nombres }}</td>
                            <td>
                                {{ props.item.apellidoPaterno }}
                                {{ props.item.apellidoMaterno }}
                            </td>
                            <td>{{ props.item.curp }}</td>
                            <td>{{ props.item.rfc }}</td>
                            <td>
                                <v-btn-toggle borderless>
                                    <v-btn @click="updateEmployee(props.item, props.item.id)" outlined>
                                        <v-icon>mdi-pencil</v-icon>
                                    </v-btn>

                                    <v-btn @click="deleteEmployee(props.item.id)" outlined>
                                        <v-icon>mdi-delete</v-icon>
                                    </v-btn>


                                </v-btn-toggle>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>
        </div>
    </v-container>
</template>


<script>
import { ref, onUnmounted } from "vue";
import {
    db,
    collection,
    doc,
    deleteDoc,
    setDoc,
    addDoc,
    orderBy,
    query,
    onSnapshot,
} from "../../firebase/index.js";

// crea un nuevo objeto `Date`
var today = new Date();

// obtener la fecha y la hora
var now = today;
console.log(now);
import Swal from 'sweetalert2'
export default {
    data() {
        return {
            datosempleados: {
                id: "",
                nombres: "",
                apellidoPaterno: "",
                apellidoMaterno: "",
                fechaNacimiento: null,
                curp: "",
                rfc: "",
                telefono: "",
                email: "",
                cruzamiento1: "",
                cruzamiento2: "",
                numeroInterior: "",
                numeroExterior: "",
                codigoPostal: "",
                pais: "",
                entidad: "",
                municipio: "",
                localidad: "",
                colonia: "",
            },
            valid: true,
            dialog: false,
            notifications: false,
            sound: true,
            widgets: false,
            search: "",
            nameRules: [
                (v) => !!v || "Este campo es requerido",
                (v) => /^[a-zA-Z\s]*$/.test(v) || "Solo se permiten letras",
            ],
            curpRules: [
                (v) => !!v || "Este campo es requerido",
                (v) => (v && v.length >= 17 && v && v.length <= 18) || "CURP inválida",
            ],
            rfcRules: [
                (v) => !!v || "Este campo es requerido",
                (v) => (v && v.length >= 12 && v && v.length <= 13) || "RFC invalida",
            ],
            phoneRules: [
                (v) => !!v || "Este campo es requerido",
                (v) => /^[0-9]{10}$/.test(v) || "Número de teléfono inválido",
            ],
            emailRules: [
                (v) => !!v || "Este campo es requerido",
                (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || "Email inválido",
            ],
            postalCodeRules: [
                (v) => !!v || "Este campo es requerido",
                (v) => /^\d{5}$/.test(v) || "Código Postal inválido",
            ],
            countriRules: [
                (v) => !!v || "Este campo es requerido",
                (v) => (v && v.length >= 4) || "Campo requerido",
            ],

            headers: [
                {
                    text: "Nombres",
                    align: "start",
                    sortable: false,
                    value: "nombres",
                },
                { text: "Apellido", value: "apellidoPaterno" },
                { text: "CURP", value: "curp" },
                { text: "RFC", value: "rfc" },
                { text: "Acciones", value: "" },
            ],
            Employees: [],
        };
    },
    methods: {
        addEmployee() {
            console.log("Prueba")
            this.datosempleados = {};
            this.resetForm();

        },
        resetForm() {
            this.datosempleados.nombres = "";
            this.datosempleados.apellidoPaterno = "";
            this.datosempleados.apellidoMaterno = "";
            this.datosempleados.fechaNacimiento = null;
            this.datosempleados.curp = "";
            this.datosempleados.rfc = "";
            this.datosempleados.telefono = "";
            this.datosempleados.email = "";
            this.datosempleados.cruzamiento1 = "";
            this.datosempleados.cruzamiento2 = "";
            this.datosempleados.numeroInterior = "";
            this.datosempleados.numeroExterior = "";
            this.datosempleados.codigoPostal = "";
            this.datosempleados.pais = "";
            this.datosempleados.entidad = "";
            this.datosempleados.municipio = "";
            this.datosempleados.localidad = "";
            this.datosempleados.colonia = "";
            this.$refs.form.resetValidation(); // Resetear la validación del formulario
        },
        submitForm() {


            try {
                if (this.datosempleados.id) {
                    // Update existing Employee
                    this.updateEmployee(this.datosempleados);
                    Swal.fire({
                        position: "center",
                        icon: "success",
                        title: "Informacion de empleado actualizada",
                        showConfirmButton: false,
                        timer: 1500,
                    });
                } else {
                    // Add new Employee

                    if (
                        addDoc(collection(db, "Employees"), {
                            nombres: this.datosempleados.nombres,
                            apellidoPaterno: this.datosempleados.apellidoPaterno,
                            apellidoMaterno: this.datosempleados.apellidoMaterno,
                            fechaNacimiento: null,
                            curp: this.datosempleados.curp,
                            rfc: this.datosempleados.rfc,
                            telefono: this.datosempleados.telefono,
                            email: this.datosempleados.email,
                            cruzamiento1: this.datosempleados.cruzamiento1,
                            cruzamiento2: this.datosempleados.cruzamiento2,
                            numeroInterior: this.datosempleados.numeroInterior,
                            numeroExterior: this.datosempleados.numeroExterior,
                            codigoPostal: this.datosempleados.codigoPostal,
                            pais: this.datosempleados.pais,
                            entidad: this.datosempleados.entidad,
                            municipio: this.datosempleados.municipio,
                            localidad: this.datosempleados.localidad,
                            colonia: this.datosempleados.colonia,
                            date: Date(),

                        })) {
                        Swal.fire({
                            position: "center",
                            icon: "success",
                            title: "Empleado registrado con exito",
                            showConfirmButton: false,
                            timer: 1500,
                        });
                    } else {
                        Swal.fire({
                            icon: "error",
                            title: "Oops...",
                            text: "Algo a fallado",
                            footer: 'Descuida, intentalo de nuevo o comunicate con tu proveedor',
                        });
                    }

                }
                this.dialog = false;
                this.resetForm();
            } catch (error) {
                Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "A ocurrido un error: " + error.message,
                    footer: 'Descuida, intentalo de nuevo o comunicate con tu proveedor',
                });
                console.error("Error en el guardado" + error)
            }


        },
        deleteEmployee(id) {


            Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    deleteDoc(doc(db, "Employees", id));
                    Swal.fire(
                        'Deleted!',
                        'Your file has been deleted.',
                        'success'
                    )
                }
            })
        },
        updateEmployee: function (item, id) {
            this.dialog = true;
            this.datosempleados = { ...item };
            setDoc(doc(db, "Employees", item.id), {
                nombres: item.nombres,
                apellidoPaterno: item.apellidoPaterno,
                apellidoMaterno: item.apellidoMaterno,
                fechaNacimiento: null,
                curp: item.curp,
                rfc: item.rfc,
                telefono: item.telefono,
                email: item.email,
                cruzamiento1: item.cruzamiento1,
                cruzamiento2: item.cruzamiento2,
                numeroInterior: item.numeroInterior,
                numeroExterior: item.numeroExterior,
                codigoPostal: item.codigoPostal,
                pais: item.pais,
                entidad: item.entidad,
                municipio: item.municipio,
                localidad: item.localidad,
                colonia: item.colonia,
                date: Date(),
            });
        },
    },
    mounted() {
        const latestQuery = query(collection(db, "Employees"), orderBy("date"));
        this.liveEmployees = onSnapshot(latestQuery, (snapshot) => {
            this.Employees = snapshot.docs.map((doc) => ({
                id: doc.id,
                nombres: doc.data().nombres,
                apellidoPaterno: doc.data().apellidoPaterno,
                apellidoMaterno: doc.data().apellidoMaterno,
                fechaNacimiento: null,
                curp: doc.data().curp,
                rfc: doc.data().rfc,
                telefono: doc.data().telefono,
                email: doc.data().email,
                cruzamiento1: doc.data().cruzamiento1,
                cruzamiento2: doc.data().cruzamiento2,
                numeroInterior: doc.data().numeroInterior,
                numeroExterior: doc.data().numeroExterior,
                codigoPostal: doc.data().codigoPostal,
                pais: doc.data().pais,
                entidad: doc.data().entidad,
                municipio: doc.data().municipio,
                localidad: doc.data().localidad,
                colonia: doc.data().colonia,
            }));
        });
    },
};
</script> 

  